import React from 'react';
export default function HeadphonesSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Headband */}
      <path d="M6 22 C6 10 12 4 20 4 C28 4 34 10 34 22" stroke="#37474F" strokeWidth="3" fill="none" strokeLinecap="round" />
      {/* Headband padding */}
      <path d="M14 5 C16 3 24 3 26 5" stroke="#546E7A" strokeWidth="4" fill="none" strokeLinecap="round" />

      {/* Left ear cup - outer */}
      <rect x="1" y="18" width="10" height="16" rx="4" fill="#37474F" />
      {/* Left ear cup - padding */}
      <rect x="2" y="19" width="8" height="14" rx="3" fill="#546E7A" />
      {/* Left ear cup - center */}
      <ellipse cx="6" cy="26" rx="2.5" ry="4" fill="#455A64" />

      {/* Right ear cup - outer */}
      <rect x="29" y="18" width="10" height="16" rx="4" fill="#37474F" />
      {/* Right ear cup - padding */}
      <rect x="30" y="19" width="8" height="14" rx="3" fill="#546E7A" />
      {/* Right ear cup - center */}
      <ellipse cx="34" cy="26" rx="2.5" ry="4" fill="#455A64" />

      {/* Cushion highlights */}
      <path d="M3 22 L3 24" stroke="#78909C" strokeWidth="1" strokeLinecap="round" opacity="0.5" />
      <path d="M37 22 L37 24" stroke="#78909C" strokeWidth="1" strokeLinecap="round" opacity="0.5" />

      {/* Small music note accent */}
      <circle cx="6" cy="26" r="1" fill="#E8762E" />
      <circle cx="34" cy="26" r="1" fill="#E8762E" />
    </svg>
  );
}
